import { render } from "./DefaultDetailArticle.vue?vue&type=template&id=51b301b5&scoped=true"
import script from "./DefaultDetailArticle.vue?vue&type=script&lang=js"
export * from "./DefaultDetailArticle.vue?vue&type=script&lang=js"

import "./DefaultDetailArticle.vue?vue&type=style&index=0&id=51b301b5&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\moolng-cms-parent\\moolng-lunzhongyi-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b301b5"]])

export default __exports__